export default "__VITE_ASSET__1da5f9fd__"